import React from 'react';
import styled from 'styled-components';

import UsersTableView from '../../table/UsersTableView';

const StyledTableView = styled(UsersTableView)`
  overflow-y: auto;
  height: 100%;
  width: 100%;

  .full-height {
    height: 100%;
    width: 100%;
  }
`;

const UserPreview = ({ tableConfig }) => <StyledTableView tableConfig={tableConfig} />;

export default UserPreview;
